export const Status  = {
  closed: -3,
  canceled_from_provider : -2,
  rejected : -1,
  canceled : 0,
  unconfirmed : 1,
  in_progress : 2,
  completed : 3,
  completed_complete : 4,
  complete : 5,
}

export const StatusName =  {
  closed: 'Closed',
  canceled_from_provider : 'Canceled From Provider',
  rejected: 'Rejected',
  canceled : 'Canceled',
  unconfirmed : 'Order Placed',
  in_progress : 'Order Confirmed',
  completed : 'Ready',
  picked_up : 'Picked up',
  complete : 'Completed',
  completed_complete : 'Picked up'
}

export const StatusType =   {
  COMPLETED : 'completed',
  PICKUP_COMPLETE : 'pickup_complete',
  CANCELED_FROM_PROVIDER : 'canceled_from_provider',
  COMPLETED_COMPLETE: "completed_complete",
  CANCELED : 'canceled'
}

export const HAS_NOT_TRACK_PROVIDER = {
  doordash: 'doordash'
}
